const SelectDeselectAllMixin = {
  computed: {
    selectedItems () {
      return this.modelValue[this.value.name] || []
    },
    allSelected () {
      return this.selectedItems.length === this.value.options.length
    },
    someSelected () {
      return this.selectedItems.length > 0 && !this.allSelected
    },
    noneSelected () {
      return this.selectedItems.length === 0
    },
    selectIcon () {
      if (this.allSelected) return 'mdi-close-box'
      if (this.someSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    updateQueryParam (val) {
      this.$emit('update-query-param-value', { name: this.paramName, key: this.value.name, value: val })
    },
    toggle () {
      this.$nextTick(() => {
        if (this.allSelected) {
          this.updateQueryParam([])
        } else {
          this.updateQueryParam(this.value.options)
        }
      })
    }
  }
}

export default SelectDeselectAllMixin
